import { render, staticRenderFns } from "./MStudio.vue?vue&type=template&id=05c5cfe4&scoped=true&"
import script from "./MStudio.vue?vue&type=script&lang=js&"
export * from "./MStudio.vue?vue&type=script&lang=js&"
import style0 from "./MStudio.vue?vue&type=style&index=0&id=05c5cfe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5cfe4",
  null
  
)

export default component.exports